import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';

import { notifications } from '@mantine/notifications';
import { CreateAddressOnlinePayload, UpdateAddressOnlinePayload } from '../models/payload/address';
import { OnlineAddress, OnlineAddressResponse } from '../models/response/address';
import {
  createCustomerOnlineAddress,
  getCustomerOnlineAddress,
  removeCustomerAddress,
  updateCustomerOnlineAddress,
} from '../services/address';
// eslint-disable-next-line import/no-cycle
import { createAppAsyncThunk } from '../utils/reduxUtil';

interface AddressState {
  items: OnlineAddress[];
  loading: boolean;
}

const initialState: AddressState = {
  items: [],
  loading: false,
};

const getAllAddresses = createAppAsyncThunk<OnlineAddressResponse, void>('address/getAddresses', async () => {
  const response = await getCustomerOnlineAddress();
  return response;
});

const addAddress = createAppAsyncThunk<void, CreateAddressOnlinePayload>(
  'address/addAddress',
  async (input, { dispatch }) => {
    try {
      await createCustomerOnlineAddress(input);
      notifications.show({
        message: 'آدرس با موفقیت ثبت گردید',
        color: 'green',
      });

      await dispatch(getAllAddresses());
    } catch (error) {
      notifications.show({
        message: 'خطا در ثبت آدرس',
        color: 'danger',
      });
    }
  }
);

const editAddress = createAppAsyncThunk<void, UpdateAddressOnlinePayload>(
  'address/editAddress',
  async (input, { dispatch }) => {
    try {
      await updateCustomerOnlineAddress(input);

      notifications.show({
        message: 'آدرس ویرایش شد',
        color: 'green',
      });
      await dispatch(getAllAddresses());
    } catch (error) {
      notifications.show({
        message: 'خطا در ویرایش آدرس',
        color: 'danger',
      });
    }
  }
);

const removeAddress = createAppAsyncThunk<void, string>('address/removeAddress', async (id, { dispatch }) => {
  const response = await removeCustomerAddress(id);
  dispatch(getAllAddresses());
  return response;
});

const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<AddressState>) => {
    builder.addCase(getAllAddresses.pending, (state) => ({ ...state, loading: true, items: [] }));

    builder.addCase(getAllAddresses.fulfilled, (state, action) => ({
      ...state,
      loading: false,
      items: action.payload.data || [],
    }));

    builder.addCase(getAllAddresses.rejected, (state) => ({
      ...state,
      loading: false,
    }));
    builder.addCase(addAddress.pending, (state) => ({
      ...state,
      loading: true,
    }));

    builder.addCase(addAddress.fulfilled, (state) => ({
      ...state,
      loading: false,
    }));

    builder.addCase(editAddress.pending, (state) => ({
      ...state,
      loading: true,
    }));

    builder.addCase(editAddress.fulfilled, (state) => ({
      ...state,
      loading: false,
    }));
  },
});

export default addressSlice;
export { addAddress, editAddress, getAllAddresses, removeAddress };
